import React from "react";

/**
 * Loading skeleton for a single game card. Matches GameCard's 4:3 image aspect
 * so the grid does not shift when real cards swap in. Uses the shimmer
 * treatment (animate-shimmer) rather than a bare pulse to read as "premium,
 * loading" rather than "broken".
 *
 * @param {{ count?: number }} props - how many skeleton cards to render.
 */
const GameCardSkeleton = ({ count = 5 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="bg-card rounded-lg overflow-hidden animate-shimmer aspect-[4/3]"
        aria-hidden="true"
      />
    ))}
  </>
);

export default GameCardSkeleton;
